export var WeekDayEnum;
(function (WeekDayEnum) {
    WeekDayEnum["MON"] = "mon";
    WeekDayEnum["TUE"] = "tue";
    WeekDayEnum["WED"] = "wed";
    WeekDayEnum["THU"] = "thu";
    WeekDayEnum["FRI"] = "fri";
    WeekDayEnum["SAT"] = "sat";
    WeekDayEnum["SUN"] = "sun";
})(WeekDayEnum || (WeekDayEnum = {}));
//# sourceMappingURL=WeekDayEnum.js.map